import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  max-width: 1440px;

  @media ${(props) => props.theme.device.laptopL} {
    justify-content: center;
  }
`;

export const StoryRow = styled.div<{ reverse?: boolean }>`
  display: flex;
  flex-direction: column;

  &:last-child {
    margin-bottom: 0;
  }

  @media ${(props) => props.theme.device.laptop} {
    flex-direction: ${(props) => (props.reverse ? 'row-reverse' : 'row')};
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex: 1;

  @media ${(props) => props.theme.screen.lg} {
    flex: 0 0 55%;
  }

  @media ${(props) => props.theme.device.laptopL} {
    flex: 0 0 60%;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Content = styled.div<{ darkBackground?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding: 37px 60px 60px;
  background-color: ${(props) =>
    props.darkBackground
      ? props.theme.colors.black
      : props.theme.colors.gray13};

  flex: 0 0 45%;

  @media ${(props) => props.theme.device.laptop} {
    padding: 37px 93px 93px;
  }

  @media ${(props) => props.theme.device.laptopL} {
    flex: 0 0 40%;
  }
`;

export const NumberText = styled.span<{ darkBackground?: boolean }>`
  text-align: ${(props) => (props.darkBackground ? 'right' : 'left')};
  font-family: ${(props) => props.theme.fontFamilies.sfPro};
  font-weight: 510;
  font-size: 96px;
  line-height: 130%;
  color: ${(props) =>
    props.darkBackground ? props.theme.colors.white : props.theme.colors.black};
`;

export const BodyText = styled.p<{ darkBackground?: boolean }>`
  white-space: pre-line;
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;
  color: ${(props) =>
    props.darkBackground
      ? props.theme.colors.gray13
      : props.theme.colors.black};
  margin: 0;
`;

export const Subtitle = styled.p<{ darkBackground?: boolean }>`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  font-size: 14px;
  line-height: 130%;
  letter-spacing: 0%;
  color: ${(props) =>
    props.darkBackground ? props.theme.colors.white : props.theme.colors.black};
  margin: 0;
`;
